import { render, staticRenderFns } from "./quanbudingdandetailCopy.vue?vue&type=template&id=503d903d&scoped=true"
import script from "./quanbudingdandetailCopy.vue?vue&type=script&lang=js"
export * from "./quanbudingdandetailCopy.vue?vue&type=script&lang=js"
import style0 from "./quanbudingdandetailCopy.vue?vue&type=style&index=0&id=503d903d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "503d903d",
  null
  
)

export default component.exports